module.exports = __webpack_public_path__ + "static/media/arina-2.b64c28d1.jpg";